export * from "./backgroundMaterial.js";
//# sourceMappingURL=index.js.map